import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

const PermCtx = createContext({ pages: [], roles: {}, labels: {}, options: {}, mine: null, reload: () => {} });

export function PermissionsProvider({ children }) {
  const { user } = useAuth();
  const [state, setState] = useState({ pages: [], roles: {}, labels: {}, options: {}, mine: null });
  const reload = useCallback(() => api.get("/permissions").then((r) => setState(r.data)).catch(() => setState((s) => ({ ...s, mine: [] }))), []);
  useEffect(() => { if (user) reload(); else setState({ pages: [], roles: {}, labels: {}, options: {}, mine: null }); }, [user, reload]);
  const value = useMemo(() => ({ ...state, reload }), [state, reload]);
  return <PermCtx.Provider value={value}>{children}</PermCtx.Provider>;
}

export const usePermissions = () => useContext(PermCtx);

export const PAGE_LABELS = {
  dashboard: "Özet & Genel Bakış", ingredients: "Malzeme Deposu", recipes: "Ürün & Reçete", guide: "Tarifler", stock: "Stok Takibi", retail: "Perakende Satış", retail_stock: "Herbalife Stok",
  sales: "Kasa & Satış", finances: "Gelir / Gider", reports: "Kâr / Zarar", zreport: "Günlük Z Raporu", club: "Beslenme Kulübü", settings: "Hesap Ayarları",
};
